import React, { useContext } from "react";
import PropTypes from "prop-types";
import { GlobalContext } from "GlobalContext";
import DatedCard from "ui/DatedCard";

const NewsCard = ({ data, revealDelay }) => {
  const { currentLang } = useContext(GlobalContext);
  const { slug, title, date, actualites, categories } = data;
  const category = categories ? categories.nodes[0].slug : "uncategorized";
  const base = currentLang === "en" ? "/news" : "/actualite";

  return (
    <DatedCard
      className="news-card"
      path={base + "/" + category + "/" + slug}
      image={actualites.global.visuelActualite}
      date={date}
      title={title}
      revealDelay={revealDelay}
    />
  );
};

NewsCard.propTypes = {
  revealDelay: PropTypes.number,
};

export default NewsCard;
